import { render, staticRenderFns } from "./PrivilegesReview.vue?vue&type=template&id=5d17ad00&"
import script from "./PrivilegesReview.vue?vue&type=script&lang=js&"
export * from "./PrivilegesReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports